import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingDark from "@/pages/LandingDark";
import LandingLight from "@/pages/LandingLight";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingDark />} />
          <Route path="/light" element={<LandingLight />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
